import { NgModule } from '@angular/core';
import { NgxJqueryDatatableComponent } from './ngx-jquery-datatable.component';



@NgModule({
  declarations: [NgxJqueryDatatableComponent],
  imports: [
  ],
  exports: [NgxJqueryDatatableComponent]
})
export class NgxJqueryDatatableModule { }
